<mat-accordion [ngClass]="{ 'has-border': hasTopBorder }" class="table-filter-panel" displayMode="flat">
    <mat-expansion-panel class="w-100" [expanded]="expanded" #expansionPanel>
        <mat-expansion-panel-header><ng-content select="[expansionHeader]"></ng-content></mat-expansion-panel-header>
        <ng-content></ng-content>
    </mat-expansion-panel>
</mat-accordion>
